import forEach from 'lodash/forEach';

const CardStatistics = {
  create(node, options) {
    this.node = node;
    this.options = options;

    this.$dateSelect = $(this.node).find('.js-card-statistics-select');
    this.$fromDate = $(this.node).find('.js-card-statistics-from');
    this.$toDate = $(this.node).find('.js-card-statistics-to');
    this.$output = $(this.node).find('.js-card-statistics-output');

    this.cardTemplate = $(this.node).find('.js-card-statistics-template').html();

    this.createListeners();

    const existingSettings = this.retrieveSettings();

    if (existingSettings) {
      this.setExistingSettings(existingSettings);
    }

    this.run = () => {
      this.fetch(this.getDates())
        .then(this.outputCards.bind(this))
        .then(this.storeSettings.bind(this));
    };

    this.run();
  },

  createListeners() {
    this.$dateSelect.on('change', () => {
      this.changeQuickDate();
    });

    this.$fromDate.add(this.$toDate).on('change', () => {
      this.run();
    });
  },

  changeQuickDate() {
    const dateRange = this.$dateSelect.val();
    let start;
    let end;

    if (dateRange.indexOf('/') >= 0) {
      [start, end] = dateRange.split('/');
    } else {
      start = dateRange;
      end = dateRange;
    }

    this.outputToDatepickers(start, end);
    this.run();
  },

  outputToDatepickers(start, end) {
    this.$fromDate.val(start);
    this.$toDate.val(end);
  },

  getDates() {
    return {
      from: this.$fromDate.val(),
      to: this.$toDate.val(),
      title: this.$dateSelect.val(),
    };
  },

  fetch(dates) {
    return window.axios.get(this.options.cardStatisticsApi, { params: dates })
      .then((data) => data.data)
      .catch(() => {
        // console.error(err);
      });
  },

  outputCards(data) {
    const cards = [];

    forEach(data, (item) => {
      let card = this.cardTemplate
        .replace('##href##', item.href)
        .replace('##title##', item.key)
        .replace('##stat##', item.value);

      let infoBubble = '';

      if (typeof item.info !== 'undefined') {
        infoBubble = `
          <button
            type="button"
            class="btn btn-round btn-round-small btn-primary"
            data-toggle="tooltip"
            data-original-title="${item.info}"
          >
            <i class="fas fa-info" aria-hidden="true"></i>
            <span class="sr-only">Meer informatie</span>
          </button>
        `;
      }

      card = card.replace('##info##', infoBubble);

      cards.push(card);
    });

    this.$output.html(cards.join(''));
    this.reinitializeTooltips();
  },

  hasLocalStorage() {
    return (typeof window.localStorage !== 'undefined' && typeof window.localStorage.setItem === 'function');
  },

  getLocalStorageKey() {
    return `cardStats_${window.location.href.split('?')[0]}`;
  },

  storeSettings() {
    if (!this.hasLocalStorage()) {
      return;
    }

    window.localStorage.setItem(this.getLocalStorageKey(), JSON.stringify(this.getDates()));
  },

  retrieveSettings() {
    if (!this.hasLocalStorage()) {
      return null;
    }

    return JSON.parse(window.localStorage.getItem(this.getLocalStorageKey()));
  },

  setExistingSettings(settings) {
    this.$fromDate.val(settings.from);
    this.$toDate.val(settings.to);

    if (this.$dateSelect.find(`option[value="${settings.title}"]`).length) {
      this.$dateSelect.val(settings.title);
    }
  },

  reinitializeTooltips() {
    $('[data-toggle="tooltip"]').tooltip();
  },
};

export default CardStatistics;
